module.exports = __webpack_public_path__ + "static/media/1 14 godt.a94a0864.mp3";